export default "__VITE_ASSET__CdTE4hjC__"